export class PropertyPath {
  public static get(propertyFunction: (m: any) => any) {
    const fnBody = getArrowFunctionBody(propertyFunction);
    if (fnBody) {
      const result = fnBody.split('.');
      result.shift();
      return result.join('.');
    } else {
      console.error(`A property path could not be extracted from the supplied function: ${propertyFunction.toString()}`);

      return '';
    }
  }
}

const getArrowFunctionBody = (f: any) => {

  const matches = f.toString().match(/^(?:\s*\(?(?:\s*[\w$]*\s*,?\s*)*\)?\s*?=>\s*){?([\s\S]*)}?$/);

  if (!matches) {
    return null;
  }

  const firstPass = matches[1];

  // Needed because the RegExp doesn't handle the last '}'.
  const secondPass =
    (firstPass.match(/{/g) || []).length === (firstPass.match(/}/g) || []).length - 1 ?
      firstPass.slice(0, firstPass.lastIndexOf('}')) :
      firstPass;

  return secondPass;
}
